import { render } from "./MemoruContent.vue?vue&type=template&id=038bafb2&scoped=true&ts=true"
import script from "./MemoruContent.vue?vue&type=script&lang=ts"
export * from "./MemoruContent.vue?vue&type=script&lang=ts"

import "./MemoruContent.vue?vue&type=style&index=0&id=038bafb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038bafb2"]])

export default __exports__